export default __webpack_public_path__ + "img/3b5872e0cdc7fd420e57f5e8bc8f113a.svg";